import { ProductSearchComponent } from "@coworker/apprestructured/src/scan-and-search/pages/product-search-page/ProductSearchComponent";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { useTranslation } from "@coworker/locales";
import { useId, useState } from "react";
import { joinClassNames } from "../utils";
import styles from "./article-search-prompt.module.css";

type ArticleSearchPromptProps = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onSelect: (item: Item) => void;
  errorMessage?: string;
};

export const ArticleSearchPrompt = ({
  isOpen,
  title,
  onClose,
  onSelect,
  errorMessage,
}: ArticleSearchPromptProps) => {
  const { t } = useTranslation();
  const id = useId();
  const headerTitleId = `${id}-title`;
  const [searchQuery, setSearchQuery] = useState("");
  const [hasContent, setHasContent] = useState(false);
  const [wasOpen, setWasOpen] = useState(isOpen);

  if (wasOpen !== isOpen) {
    setWasOpen(isOpen);
    if (!isOpen) {
      setSearchQuery("");
      setHasContent(false);
    }
  }

  const isExpanded = hasContent && searchQuery.trim().length > 0;

  return (
    <FixaModal
      data-testid="article-search-prompt"
      visible={isOpen}
      handleCloseBtn={onClose}
    >
      <FixaPrompt
        className={joinClassNames(
          styles["prompt"],
          isExpanded && styles["prompt_expanded"]
        )}
        footer={null}
        header={
          <FixaModalHeader
            title={title}
            titleId={headerTitleId}
            ariaCloseTxt={t("closeActionString")}
            closeBtnClick={onClose}
          />
        }
        title=""
        titleId={`${id}-prompt-heading`}
        aria-labelledby={headerTitleId}
      >
        {errorMessage && (
          <div className={styles["error"]}>
            <FixaInlineMessage variant="negative" title={errorMessage} />
          </div>
        )}
        <ProductSearchComponent
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleItemCardClick={onSelect}
          itemCardRenderType={SearchItemCardRenderType.button}
          shouldHideSPRItems={false}
          shouldHideLocalCombinationItems={false}
          shouldHideHistory
          placeholder={t("searchArticleString")}
          onHasContentChange={setHasContent}
        />
      </FixaPrompt>
    </FixaModal>
  );
};
